module.exports = __webpack_public_path__ + "static/media/location-pin.83ee3310.svg";